import type { ReactNode } from "react";
import { Link } from "react-router";
import cn from "classnames";
import { ChevronRightIcon } from "@/shared/assets/icons";
import Skeleton from "@/shared/ui/Skeleton";

export type Crumb = {
  label: string;
  href?: string;
  loading?: boolean;
  content?: ReactNode;
};

interface Props {
  items: Crumb[];
  className?: string;
}

export default function Breadcrumbs({ items, className }: Props) {
  return (
    <nav className={cn("flex flex-wrap items-center gap-1", className)}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={`${item.label}-${index}`} className="flex items-center gap-1">
            {item.loading ? (
              <Skeleton width={80} height={16} borderRadius={4} />
            ) : item.content ? (
              item.content
            ) : isLast ? (
              <span className="text-brand-600 text-label-sm">{item.label}</span>
            ) : item.href ? (
              <Link to={item.href} className="content-action-neutral text-label-sm">
                {item.label}
              </Link>
            ) : (
              <span className="content-action-neutral text-label-sm">{item.label}</span>
            )}

            {!isLast && (
              <div className="icon-secondary w-5 aspect-square flex items-center justify-center">
                <ChevronRightIcon />
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
}

